// class CartRemoveButton extends HTMLElement{constructor(){super(),this.addEventListener("click",(e=>{e.preventDefault();(this.closest("cart-items")||this.closest("cart-drawer-items")).updateQuantity(this.dataset.index,0)}))}}customElements.define("cart-remove-button",CartRemoveButton);class CartItems extends HTMLElement{constructor(){super(),this.lineItemStatusElement=document.getElementById("shopping-cart-line-item-status")||document.getElementById("CartDrawer-LineItemStatus");const e=debounce((e=>{this.onChange(e)}),ON_CHANGE_DEBOUNCE_TIMER);this.addEventListener("change",e.bind(this))}cartUpdateUnsubscriber=void 0;connectedCallback(){this.cartUpdateUnsubscriber=subscribe(PUB_SUB_EVENTS.cartUpdate,(e=>{"cart-items"!==e.source&&this.onCartUpdate()}))}disconnectedCallback(){this.cartUpdateUnsubscriber&&this.cartUpdateUnsubscriber()}onChange(e){this.updateQuantity(e.target.dataset.index,e.target.value,document.activeElement.getAttribute("name"))}onCartUpdate(){fetch(`${routes.cart_url}?section_id=main-cart-items`).then((e=>e.text())).then((e=>{const t=(new DOMParser).parseFromString(e,"text/html").querySelector("cart-items");this.innerHTML=t.innerHTML})).catch((e=>{console.error(e)}))}getSectionsToRender(){return[{id:"main-cart-items",section:document.getElementById("main-cart-items").dataset.id,selector:".js-contents"},{id:"cart-icon-bubble",section:"cart-icon-bubble",selector:".shopify-section"},{id:"cart-live-region-text",section:"cart-live-region-text",selector:".shopify-section"},{id:"main-cart-footer",section:document.getElementById("main-cart-footer").dataset.id,selector:".js-contents"}]}updateQuantity(e,t,r){this.enableLoading(e);const n=JSON.stringify({line:e,quantity:t,sections:this.getSectionsToRender().map((e=>e.section)),sections_url:window.location.pathname});fetch(`${routes.cart_change_url}`,{...fetchConfig(),body:n}).then((e=>e.text())).then((t=>{const n=JSON.parse(t),a=document.getElementById(`Quantity-${e}`)||document.getElementById(`Drawer-quantity-${e}`),i=document.querySelectorAll(".cart-item");if(n.errors)return a.value=a.getAttribute("value"),void this.updateLiveRegions(e,n.errors);this.classList.toggle("is-empty",0===n.item_count);const s=document.querySelector("cart-drawer"),o=document.getElementById("main-cart-footer");o&&o.classList.toggle("is-empty",0===n.item_count),s&&s.classList.toggle("is-empty",0===n.item_count),this.getSectionsToRender().forEach((e=>{(document.getElementById(e.id).querySelector(e.selector)||document.getElementById(e.id)).innerHTML=this.getSectionInnerHTML(n.sections[e.section],e.selector)}));const c=n.items[e-1]?n.items[e-1].quantity:void 0;let d="";i.length===n.items.length&&c!==parseInt(a.value)&&(d=void 0===c?window.cartStrings.error:window.cartStrings.quantityError.replace("[quantity]",c)),this.updateLiveRegions(e,d);const l=document.getElementById(`CartItem-${e}`)||document.getElementById(`CartDrawer-Item-${e}`);l&&l.querySelector(`[name="${r}"]`)?s?trapFocus(s,l.querySelector(`[name="${r}"]`)):l.querySelector(`[name="${r}"]`).focus():0===n.item_count&&s?trapFocus(s.querySelector(".drawer__inner-empty"),s.querySelector("a")):document.querySelector(".cart-item")&&s&&trapFocus(s,document.querySelector(".cart-item__name")),publish(PUB_SUB_EVENTS.cartUpdate,{source:"cart-items"})})).catch((()=>{this.querySelectorAll(".loading-overlay").forEach((e=>e.classList.add("hidden")));(document.getElementById("cart-errors")||document.getElementById("CartDrawer-CartErrors")).textContent=window.cartStrings.error})).finally((()=>{this.disableLoading(e)}))}updateLiveRegions(e,t){const r=document.getElementById(`Line-item-error-${e}`)||document.getElementById(`CartDrawer-LineItemError-${e}`);r&&(r.querySelector(".cart-item__error-text").innerHTML=t),this.lineItemStatusElement.setAttribute("aria-hidden",!0);const n=document.getElementById("cart-live-region-text")||document.getElementById("CartDrawer-LiveRegionText");n.setAttribute("aria-hidden",!1),setTimeout((()=>{n.setAttribute("aria-hidden",!0)}),1e3)}getSectionInnerHTML(e,t){return(new DOMParser).parseFromString(e,"text/html").querySelector(t).innerHTML}enableLoading(e){(document.getElementById("main-cart-items")||document.getElementById("CartDrawer-CartItems")).classList.add("cart__items--disabled");[...this.querySelectorAll(`#CartItem-${e} .loading-overlay`),...this.querySelectorAll(`#CartDrawer-Item-${e} .loading-overlay`)].forEach((e=>e.classList.remove("hidden"))),document.activeElement.blur(),this.lineItemStatusElement.setAttribute("aria-hidden",!1)}disableLoading(e){(document.getElementById("main-cart-items")||document.getElementById("CartDrawer-CartItems")).classList.remove("cart__items--disabled");const t=this.querySelectorAll(`#CartItem-${e} .loading-overlay`),r=this.querySelectorAll(`#CartDrawer-Item-${e} .loading-overlay`);t.forEach((e=>e.classList.add("hidden"))),r.forEach((e=>e.classList.add("hidden")))}}customElements.define("cart-items",CartItems),customElements.get("cart-note")||customElements.define("cart-note",class extends HTMLElement{constructor(){super(),this.addEventListener("change",debounce((e=>{const t=JSON.stringify({note:e.target.value});fetch(`${routes.cart_update_url}`,{...fetchConfig(),body:t})}),ON_CHANGE_DEBOUNCE_TIMER))}});
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (e) => {
      e.preventDefault();
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    
    const debounceChangeHandler = debounce((e) => this.onChange(e), ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", debounceChangeHandler.bind(this));
  }

  cartUpdateUnsubscriber = null;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      if (e.source !== "cart-items") this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  async onChange(e) {
    const index = e.target.dataset.index;
    const value = e.target.value;
    const name = document.activeElement.getAttribute("name");
    await this.updateQuantity(index, value, name);
  }

  async onCartUpdate() {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=main-cart-items`);
      const text = await response.text();
      const newContent = new DOMParser().parseFromString(text, "text/html").querySelector("cart-items");
      this.innerHTML = newContent.innerHTML;
    } catch (error) {
      console.error(error);
    }
  }

  getSectionsToRender() {
    return [
      { id: "main-cart-items", section: document.getElementById("main-cart-items").dataset.id, selector: ".js-contents" },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
      { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
      { id: "main-cart-footer", section: document.getElementById("main-cart-footer").dataset.id, selector: ".js-contents" }
    ];
  }

  async updateQuantity(index, quantity, focusedElementName) {
    this.toggleLoadingState(index, true);
    const sectionsToRender = this.getSectionsToRender().map(s => s.section);
    const body = JSON.stringify({ line: index, quantity, sections: sectionsToRender, sections_url: window.location.pathname });
    
    try {
      const response = await fetch(routes.cart_change_url, { ...fetchConfig(), body });
      const data = await response.json();
      const quantityInput = document.getElementById(`Quantity-${index}`) || document.getElementById(`Drawer-quantity-${index}`);
      const cartItems = document.querySelectorAll(".cart-item");

      if (data.errors) {
        quantityInput.value = quantityInput.getAttribute("value");
        this.updateLiveRegions(index, data.errors);
        return;
      }

      this.toggleEmptyClass(data.item_count);

      // Update sections
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id);
        const newContent = this.getSectionInnerHTML(data.sections[section.section], section.selector);
        (sectionElement.querySelector(section.selector) || sectionElement).innerHTML = newContent;
      });

      const updatedQuantity = data.items[index - 1]?.quantity;
      let errorMessage = "";
      if (cartItems.length === data.items.length && updatedQuantity !== parseInt(quantityInput.value)) {
        errorMessage = updatedQuantity === undefined
          ? window.cartStrings.error
          : window.cartStrings.quantityError.replace("[quantity]", updatedQuantity);
      }

      this.updateLiveRegions(index, errorMessage);
      this.handleFocus(index, focusedElementName, data.item_count);

      publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
    } catch (error) {
      console.error(error);
      this.showError();
    } finally {
      this.toggleLoadingState(index, false);
    }
  }

  updateLiveRegions(index, message) {
    const errorElement = document.getElementById(`Line-item-error-${index}`) || document.getElementById(`CartDrawer-LineItemError-${index}`);
    if (errorElement) {
      errorElement.querySelector(".cart-item__error-text").innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const liveRegion = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    liveRegion.setAttribute("aria-hidden", false);
    setTimeout(() => liveRegion.setAttribute("aria-hidden", true), 1000);
  }

  getSectionInnerHTML(sectionHTML, selector) {
    return new DOMParser().parseFromString(sectionHTML, "text/html").querySelector(selector).innerHTML;
  }

  toggleLoadingState(index, isLoading) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.toggle("cart__items--disabled", isLoading);

    const loadingOverlays = [...this.querySelectorAll(`#CartItem-${index} .loading-overlay`), ...this.querySelectorAll(`#CartDrawer-Item-${index} .loading-overlay`)];
    loadingOverlays.forEach(overlay => overlay.classList.toggle("hidden", !isLoading));

    if (isLoading) {
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
  }

  toggleEmptyClass(itemCount) {
    const isEmpty = itemCount === 0;
    const mainCartFooter = document.getElementById("main-cart-footer");
    const cartDrawer = document.querySelector("cart-drawer");

    this.classList.toggle("is-empty", isEmpty);
    if (mainCartFooter) mainCartFooter.classList.toggle("is-empty", isEmpty);
    if (cartDrawer) cartDrawer.classList.toggle("is-empty", isEmpty);
  }

  handleFocus(index, focusedElementName, itemCount) {
    const cartDrawer = document.querySelector("cart-drawer");
    const focusedElement = document.getElementById(`CartItem-${index}`) || document.getElementById(`CartDrawer-Item-${index}`);

    if (focusedElement?.querySelector(`[name="${focusedElementName}"]`)) {
      if (cartDrawer) {
        trapFocus(cartDrawer, focusedElement.querySelector(`[name="${focusedElementName}"]`));
      } else {
        focusedElement.querySelector(`[name="${focusedElementName}"]`).focus();
      }
    } else if (itemCount === 0 && cartDrawer) {
      trapFocus(cartDrawer.querySelector(".drawer__inner-empty"), cartDrawer.querySelector("a"));
    } else if (document.querySelector(".cart-item") && cartDrawer) {
      trapFocus(cartDrawer, document.querySelector(".cart-item__name"));
    }
  }

  showError() {
    this.querySelectorAll(".loading-overlay").forEach(overlay => overlay.classList.add("hidden"));
    const cartErrorElement = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    cartErrorElement.textContent = window.cartStrings.error;
  }
}

customElements.define("cart-items", CartItems);

customElements.get("cart-note") ||
  customElements.define(
    "cart-note",
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", debounce((e) => {
          const note = JSON.stringify({ note: e.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: note });
        }, ON_CHANGE_DEBOUNCE_TIMER));
      }
    }
  );
